<main class="application-container">
  @if (!isProd() && !environmentHeaderDismissed()) {
  <common-environment-header
    class="env-header"
    [environment]="environmentName()!"
    [applicationVersion]="applicationVersion()"
    (environmentHeaderDismissed)="onEnvironmentHeaderDismissed()"
    [attr.data-testid]="'environment-header'"
  ></common-environment-header>
  }
  <header class="header">
    <goab-microsite-header type="live" #micrositeHeader></goab-microsite-header>
    <goab-app-header
      data-testid="app-header"
      url="/"
      heading="Assisted Living Capacity Reporting and Monitoring"
      maxContentWidth="100%"
    >
      <goab-app-header-menu
        heading="{{ userName() || '' }}"
        leadingIcon="person-circle"
        [attr.data-testid]="'app-header-whoami'"
        [attr.id]="'app-header-whoami'"
        slotName="utilities"
        type="secondary"
      >
        <a data-testid="tech-support-link-header" routerLink="/help">
          Help page
        </a>
        @if (environmentName() !== 'prod') {
        <a data-testid="cap-v2-link-header" routerLink="/v2/capacity-reporting">
          Capacity v2
        </a>
        }
        <a data-testid="sign-out-link" href="#" (click)="onLogout($event)"
          >Sign out</a
        >
      </goab-app-header-menu>
    </goab-app-header>
  </header>
  @if(doShowHelpBanner()){
  <goab-notification
    data-testid="help-banner"
    type="important"
    (onDismiss)="notificationDismissed()"
    role="region"
    aria-label="Important information about Assisted Living Capacity Reporting and Monitoring"
  >
    Please include matched beds and pending admissions as Occupied beds. For
    more detail,
    <a data-testid="tech-support-link-banner" routerLink="/help"
      >click here for the new help page</a
    >
    . Find the help page in the footer or in the logout menu.
  </goab-notification>
  }
  <section class="content">
    <router-outlet></router-outlet>
  </section>
  <goab-app-footer maxContentWidth="100%" [attr.data-testid]="'app-footer'">
    <goab-app-footer-meta-section slot="meta">
      <a data-testid="tech-support-link-footer" routerLink="/help">
        Help page
      </a>
    </goab-app-footer-meta-section>
  </goab-app-footer>
</main>
<goab-circular-progress
  data-testid="loading-spinner"
  variant="fullscreen"
  size="large"
  [message]="progressIndicatorService.progressIndicatorMessage()"
  [visible]="progressIndicatorService.isProgressIndicator()"
></goab-circular-progress>
